import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ElementImageIcon } from 'src/components/ElementImageIcon/ElementImageIcon';
import SectionHeader from '../SectionHeader/SectionHeader';
import * as styles from './Cards.module.scss';
import { headerWithDescType } from 'src/types';
import { classNames } from 'src/utils/helpers';

const CARD_DESIGN = {
  FANCY: 'fancy',
  SIMPLE: 'simple',
};

function Cards({ cards, extraContent, design, sectionHeader: { title, tagline, description } }) {
  function getCardSizes() {
    if (design === CARD_DESIGN.FANCY) {
      return {
        xs: 12,
        sm: 6,
        md: 4,
      };
    }

    // Default case, where the design is of type "simple"
    return {
      xs: 12,
      sm: 6,
      lg: 3,
    };
  }

  function getCardContainerSizes() {
    if (design === CARD_DESIGN.FANCY) {
      return {
        xs: 12,
        xl: {
          span: 10,
          offset: 1,
        },
      };
    }

    return {
      xs: 12,
      xl: 12,
    };
  }

  return (
    <Container className="py-5">
      <SectionHeader title={title} tagline={tagline} description={description} />

      <Container fluid>
        <Row>
          <Col xs={12}>
            <Row>
              <Col {...getCardContainerSizes()} className="py-3">
                <Row className="justify-content-center">
                  {cards.length &&
                    cards.map((item) => (
                      <Col {...getCardSizes()} key={item._key} className="mb-md-5 my-3">
                        <Col
                          className={classNames('h-100 rounded-2xl p-4', {
                            [styles.cardSimple]: design === CARD_DESIGN.SIMPLE,
                            [styles.cardFancy]: design === CARD_DESIGN.FANCY,
                          })}
                        >
                          <Col className="pb-md-4">
                            <ElementImageIcon icon={item.icon} />
                          </Col>
                          <Col className="font-weight-bold rfs-size-3xl">{item.title}</Col>
                          <Col className="font-weight-bold">{item.description}</Col>
                        </Col>
                      </Col>
                    ))}
                </Row>
              </Col>
              <Col xs={12}>
                <Row>
                  {extraContent &&
                    extraContent.map((item) => (
                      <Col key={item._key} xs={12}>
                        <Row className="justify-content-center">
                          <Col xs="auto" className="rfs-size-xs font-weight-semi-bold">
                            {item.title}
                          </Col>
                          <Col xs="auto" className="rfs-size-xs px-0">
                            -
                          </Col>
                          <Col xs="auto" className="text-muted rfs-size-xs">
                            {item.description}
                          </Col>
                        </Row>
                      </Col>
                    ))}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

Cards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  extraContent: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
  design: PropTypes.string.isRequired,
  sectionHeader: headerWithDescType.propTypes.isRequired,
};

Cards.defaultProps = {
  extraContent: [],
};

export default Cards;
